import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';

/**
 * A list's summary DTO (`groceryListDtoSchema`) carries only `storeId`, not
 * the store's name — so the list screen resolves it here. React Query dedupes
 * identical `storeId`s across rows into a single request each.
 */
export function StoreNameLabel({ storeId }: { storeId: string }) {
  const store = useQuery({
    queryKey: ['stores', 'get', storeId],
    queryFn: () => api.stores.get(storeId),
    staleTime: 5 * 60_000,
  });
  if (store.isPending) return <span className="text-muted">…</span>;
  if (store.isError || !store.data) return <span className="text-muted">Unknown store</span>;
  return (
    <span>
      {store.data.chain} — {store.data.name}
    </span>
  );
}
